module.exports = __webpack_public_path__ + "static/appstore-34ffd2a28484ae874f44c92bf6688384.svg";